<template>
  <div class="global-period-selector" :class="`is-${variant}`" :style="selectorStyle">
    <YearMonthSelect
      :value="period"
      :period="period"
      :top-label="topLabel"
      @change="changeGlobalPeriod"
    />
  </div>
</template>

<script>
import YearMonthSelect from '@/components/cfdis/YearMonthSelect.vue';
import { GLOBAL_PERIOD_EVENT, getGlobalPeriod, setGlobalPeriod } from '@/services/globalPeriod';

export default {
  name: 'GlobalPeriodSelector',
  components: {
    YearMonthSelect,
  },
  props: {
    topLabel: {
      type: String,
      default: 'PERIODO',
    },
    variant: {
      type: String,
      default: 'header',
    },
    width: {
      type: String,
      default: '200px',
    },
    controlHeight: {
      type: String,
      default: '52px',
    },
  },
  emits: ['change', 'loaded'],
  data() {
    return {
      period: '',
    };
  },
  computed: {
    selectorStyle() {
      return {
        '--gps-width': this.width,
        '--gps-control-height': this.controlHeight,
      };
    }
  },
  methods: {
    loadGlobalPeriod() {
      this.period = getGlobalPeriod();
      this.$emit('loaded', this.period);
    },
    changeGlobalPeriod(period) {
      const nextPeriod = setGlobalPeriod(period);
      this.period = nextPeriod;
      this.$emit('change', nextPeriod);
    },
    handleGlobalPeriodChanged(event) {
      const eventPeriod = String(event?.detail?.period || '').trim();
      if (!eventPeriod) {
        return;
      }

      this.period = eventPeriod;
      this.$emit('change', eventPeriod);
    }
  },
  mounted() {
    window.addEventListener(GLOBAL_PERIOD_EVENT, this.handleGlobalPeriodChanged);
    this.loadGlobalPeriod();
  },
  beforeDestroy() {
    window.removeEventListener(GLOBAL_PERIOD_EVENT, this.handleGlobalPeriodChanged);
  }
};
</script>

<style scoped>
.global-period-selector {
  min-width: var(--gps-width);
}

.global-period-selector :deep(.ym-select) {
  width: var(--gps-width) !important;
  max-width: var(--gps-width) !important;
}

.global-period-selector :deep(.ym-select-control) {
  height: var(--gps-control-height);
  border-radius: 8px;
  border-color: var(--sidebar-border);
  background: var(--white);
  padding: 8px 15px 7px;
}

.global-period-selector :deep(.ym-select-stacked-content) {
  text-align: left;
}

.global-period-selector :deep(.ym-select-top-label) {
  font-size: 12px;
  font-weight: 600;
  line-height: 1.15;
  color: var(--theme-font-color);
  opacity: 1;
  letter-spacing: 0;
  text-transform: none;
  margin-bottom: 5px !important;
}

.global-period-selector :deep(.ym-select-bottom-label) {
  font-size: 11px;
  line-height: 1;
  color: var(--theme-font-color);
  opacity: 0.82;
}
</style>
